module.exports = __webpack_public_path__ + "static/canadapooch-logo-42a049a543fa9dde7160c51acd2a2023.png";